var isScrollifyMove = false;
var isAnchorScroll = false;
$(document).ready(function () {
	
	$('.init').addClass('ready').removeClass('init');

	$('.watch_the_video_teaser a').click(function(){
		let id = $(this).attr('data-id');
		vnsModal.youtubeOpen(id);
		return false;
	})
});

var cmnLoadedHandler = function(){

}

var cmnBreakHandler = function(mode){

}